import React, { createContext, useContext } from "react";

// `loaded` is false until /api/config/public resolves (or fails). The app no
// longer blocks rendering on it, so anything that needs the real values (e.g.
// the reCAPTCHA site key before a form submit) should check it.
const ConfigContext = createContext({
  loaded: true,
  googleEnabled: false,
  microsoftEnabled: false,
  recaptchaSiteKey: "",
  postcardsEnabled: false,
});

export function ConfigProvider({ value, children }) {
  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
}

export function useConfig() {
  return useContext(ConfigContext);
}
